import React from "react";
import Banner from "../../components/Banner";
import { Sidebar } from "../../components/Sidebar";
import axios from "axios";
import Spinner from "../../components/Spinner";
import "../../css/Wireframe.css";

const API = localStorage.getItem("assethost");

// Flattened helper arrays
const PDF_TEMPLATE_TYPES = [
  { value: "", label: "Select" },
  { value: "INDIVIDUAL_CERTIFICATE", label: "Individual Certificate" },
  { value: "COMPANY_CERTIFICATE", label: "Company Certificate" },
  { value: "COMPANY_INVOICE", label: "Company Invoice" },
];

const ACTIVE_STATUS_OPTIONS = [
  { value: "", label: "Select" },
  { value: "YES", label: "Yes" },
  { value: "NO", label: "No" },
];

export default class PdfTemplateSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      valid: false,
      msg: "",
      toastColor: "",
      pdfTemplates: [],
      editing: false,
      page: 0,
      size: 10,
      totalPages: 1,
      // Form state
      id: 0,
      pdfTemplateType: "INDIVIDUAL_CERTIFICATE",
      templateData: "",
      activeStatus: "YES",
      errors: {},
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleCancelEdit = this.handleCancelEdit.bind(this);
    this.handlePreviousPage = this.handlePreviousPage.bind(this);
    this.handleNextPage = this.handleNextPage.bind(this);
    this.validate = this.validate.bind(this);
    this.fetchPdfTemplates = this.fetchPdfTemplates.bind(this);
  }

  componentDidMount() {
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No user session/token. Please login.",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }
    this.fetchPdfTemplates(0, 10, token);
  }

  fetchPdfTemplates(page, size, token) {
    this.setState({ loading: true, msg: "", toastColor: "" });
    axios
      .get(API + "/settings/getallpdftemplates", {
        params: { page, size },
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        let templates = [];
        let totalPages = 1;
        if (response.data && Array.isArray(response.data)) {
          templates = response.data;
        } else if (
          response.data &&
          response.data.content &&
          Array.isArray(response.data.content)
        ) {
          templates = response.data.content;
          totalPages = response.data.totalPages || 1;
        } else {
          templates = [];
        }
        this.setState({
          pdfTemplates: templates,
          page,
          totalPages,
          loading: false,
        });
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          pdfTemplates: [],
          totalPages: 1,
          loading: false,
          error:
            error?.response?.data?.message || "Failed to load PDF templates.",
          msg:
            error?.response?.data?.message || "Failed to load PDF templates.",
          toastColor: "danger",
        });
      });
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value }, this.validate);
  }

  validate() {
    const s = this.state;
    let errors = {};
    let valid = true;

    if (s.editing) {
      // Explicit validation
      if (!s.pdfTemplateType || s.pdfTemplateType.trim() === "") {
        errors.pdfTemplateType = "Template type is required";
        valid = false;
      }
      if (!s.templateData || s.templateData.trim() === "") {
        errors.templateData = "Template data is required";
        valid = false;
      }
      if (!s.activeStatus || s.activeStatus.trim() === "") {
        errors.activeStatus = "Active status is required";
        valid = false;
      }
    }
    this.setState({ errors, valid });
    return valid;
  }

  handleSave(e) {
    if (e) e.preventDefault();
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "No user session/token. Please login.",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }
    if (!this.validate()) {
      this.setState({
        msg: "Fix the errors above and try again.",
        toastColor: "danger",
      });
      return;
    }
    this.setState({ loading: true, msg: "", toastColor: "" });

    const request = {
      id: this.state.id,
      pdfTemplateType: this.state.pdfTemplateType,
      templateData: this.state.templateData,
      activeStatus: this.state.activeStatus,
    };

    const self = this;
    axios
      .post(API + "/settings/pdftemplatesave", request, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        if (response.data.success) {
          self.setState({
            msg: "PDF template saved successfully!",
            toastColor: "success",
            loading: false,
          });
          // Reset form
          self.setState({
            id: 0,
            pdfTemplateType: "INDIVIDUAL_CERTIFICATE",
            templateData: "",
            activeStatus: "YES",
            editing: false,
            errors: {},
          });
          // Refetch data
          const currentPage = self.state.page;
          self.fetchPdfTemplates(currentPage, self.state.size, token);
        } else {
          self.setState({
            msg: response.data.message || "Failed to save PDF template.",
            toastColor: "danger",
            loading: false,
          });
        }
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        self.setState({
          msg:
            error?.response?.data?.message ||
            "Failed to save PDF template. Please try again.",
          toastColor: "danger",
          loading: false,
        });
      });
  }

  handleEdit(template) {
    this.setState({
      id: template?.id || 0,
      pdfTemplateType: template?.pdfTemplateType || "INDIVIDUAL_CERTIFICATE",
      templateData: template?.templateData || "",
      activeStatus: template?.activeStatus || "YES",
      editing: true,
      errors: {},
    }, this.validate);
  }

  handleCancelEdit() {
    this.setState({
      id: 0,
      pdfTemplateType: "INDIVIDUAL_CERTIFICATE",
      templateData: "",
      activeStatus: "YES",
      editing: false,
      errors: {},
    });
  }

  handlePreviousPage() {
    if (this.state.page > 0) {
      const token = sessionStorage.getItem("token");
      this.fetchPdfTemplates(this.state.page - 1, this.state.size, token);
    }
  }

  handleNextPage() {
    if (this.state.page + 1 < this.state.totalPages) {
      const token = sessionStorage.getItem("token");
      this.fetchPdfTemplates(this.state.page + 1, this.state.size, token);
    }
  }

  render() {
    const s = this.state;
    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }

    if (s.loading) {
      return <Spinner className="" />;
    }

    return (
      <div className="min-vh-100 d-flex justify-content-between bg-white">
        <Sidebar />
        <div className="min-vh-100 flex-grow-1 d-flex flex-column">
          <Banner title="PDF Template Settings" />
          {divMsg}
          <div className="d-flex flex-column flex-grow-1 px-5 h-60">
            {s.editing ? (
              // Edit/Add Form
              <form
                className="d-flex flex-column align-items-center w-100 mt-2 pt-3 pb-2 h-100 overflow-auto"
                autoComplete="off"
                onSubmit={this.handleSave}
              >
                <div className="row g-3 mx-auto" style={{maxWidth: 62 + 'rem'}}>
                  <div className="input-group">
                    <label className="input-group-text">Template Type</label>
                    <select
                      name="pdfTemplateType"
                      className={`form-control ${
                        s.errors.pdfTemplateType ? " !border-red-500" : ""
                      }`}
                      value={s.pdfTemplateType}
                      onChange={this.handleChange}
                      required
                      autoFocus
                    >
                      {PDF_TEMPLATE_TYPES.map((type) => (
                        <option key={type.value} value={type.value}>
                          {type.label}
                        </option>
                      ))}
                    </select>
                    {s.errors.pdfTemplateType && (
                      <span className="input-group-error">
                        {s.errors.pdfTemplateType}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">Active Status</label>
                    <select
                      name="activeStatus"
                      className={`form-control ${
                        s.errors.activeStatus ? " !border-red-500" : ""
                      }`}
                      value={s.activeStatus}
                      onChange={this.handleChange}
                      required
                    >
                      {ACTIVE_STATUS_OPTIONS.map((status) => (
                        <option key={status.value} value={status.value}>
                          {status.label}
                        </option>
                      ))}
                    </select>
                    {s.errors.activeStatus && (
                      <span className="input-group-error">
                        {s.errors.activeStatus}
                      </span>
                    )}
                  </div>
                  <div className="input-group col-span-2">
                    <label className="input-group-text">Template Data</label>
                    <textarea
                      name="templateData"
                      className={`form-control ${
                        s.errors.templateData ? " !border-red-500" : ""
                      }`}
                      value={s.templateData}
                      onChange={this.handleChange}
                      rows={8}
                      required
                      placeholder="Enter PDF template data..."
                    />
                    {s.errors.templateData && (
                      <span className="input-group-error">
                        {s.errors.templateData}
                      </span>
                    )}
                  </div>
                </div>
                <div className="d-flex justify-content-center gap-3 mt-4">
                  {s.valid && (
                    <button type="submit" className="btn btn-primary">
                      Save
                    </button>
                  )}
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={this.handleCancelEdit}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            ) : (
              // Table View
              <div className="h-full w-full">
                <div className="d-flex gap-2 mb-2 align-items-baseline justify-content-between">
                  <h3 className="fw-bold">Configured PDF Templates</h3>
                  <button
                    className="hover:font-bold flex gap-1 group"
                    onClick={() => this.handleEdit(null)}
                  >
                    <i
                      className="bi bi-plus-circle group-hover:scale-105"
                      style={{ color: "black" }}
                    ></i>
                    Add
                  </button>
                </div>
                {s.pdfTemplates.length === 0 ? (
                  <div className="text-muted">No PDF templates found.</div>
                ) : (
                  <div className="overflow-x-auto w-full border h-[93%] relative overflow-y-auto">
                    <table className="table table-striped table-hover rounded">
                      <thead className="table-light sticky-top">
                        <tr>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            ID
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Type
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Template Data
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Status
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody className="">
                        {s.pdfTemplates.map((template, index) => {
                          const typeLabel =
                            PDF_TEMPLATE_TYPES.find(
                              (t) => t.value === template.pdfTemplateType
                            )?.label || template.pdfTemplateType;
                          return (
                            <tr key={index} className="hover:bg-gray-50">
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                {template.id}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                {typeLabel}
                              </td>
                              <td className="px-6 py-4 text-sm text-gray-900 max-w-xs truncate">
                                {template.templateData?.substring(0, 50)}
                                {template.templateData?.length > 50 ? "..." : ""}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                {template.activeStatus}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                                <button
                                  className="btn btn-primary"
                                  onClick={() => this.handleEdit(template)}
                                >
                                  Edit
                                </button>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
                {s.totalPages > 1 && (
                  <div className="d-flex justify-content-center align-items-center gap-2 mt-4">
                    <button
                      className="btn btn-outline"
                      disabled={s.page === 0}
                      onClick={this.handlePreviousPage}
                    >
                      Previous
                    </button>
                    <span>
                      Page {s.page + 1} of {s.totalPages}
                    </span>
                    <button
                      className="btn btn-outline"
                      disabled={s.page + 1 >= s.totalPages}
                      onClick={this.handleNextPage}
                    >
                      Next
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
          
        </div>
      </div>
    );
  }
}